import { render, staticRenderFns } from "./GiteePublishModal.vue?vue&type=template&id=1770d87c&"
import script from "./GiteePublishModal.vue?vue&type=script&lang=js&"
export * from "./GiteePublishModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "GiteePublishModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/providers/GiteePublishModal.vue
// module id = 2356
// module chunks = 1